import { AuthSignalsStateService } from './auth/auth-store.service';
import { SessionSignalsStateService } from './session/session-store.service';
import { TemplatesSignalsStateService } from './templates/templates-store.service';
import { WhatsappSignalsStateService } from './whatsapp/whatsapp-store.service';

export const applicationProviders = [
  SessionSignalsStateService,
  AuthSignalsStateService,
  WhatsappSignalsStateService,
  TemplatesSignalsStateService,
];
